// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MemberEditQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  membershipId: Types.Scalars["ID"]["input"];
}>;

export type MemberEditQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationMembershipDetails: {
    __typename?: "OrganizationMembership";
    id: string;
    inviteEmail?: string | null;
    accepted: boolean;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    roles?: Array<{
      __typename?: "OrganizationRole";
      id: string;
    } | null> | null;
  };
  getOrganizationRoles: Array<{
    __typename?: "OrganizationRole";
    id: string;
    name: string;
    updatedAt: number;
  }>;
};

export const MemberEditDocument = gql`
  query MemberEdit($organizationSlug: ID!, $membershipId: ID!) {
    getOrganizationMembershipDetails(membershipId: $membershipId) {
      id
      inviteEmail
      accepted
      user {
        id
        fullname
      }
      roles {
        id
      }
    }
    getOrganizationRoles(organizationSlug: $organizationSlug) {
      id
      name
      updatedAt
    }
  }
`;

/**
 * __useMemberEditQuery__
 *
 * To run a query within a React component, call `useMemberEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberEditQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useMemberEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    MemberEditQuery,
    MemberEditQueryVariables
  > &
    (
      | { variables: MemberEditQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemberEditQuery, MemberEditQueryVariables>(
    MemberEditDocument,
    options,
  );
}
export function useMemberEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberEditQuery,
    MemberEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberEditQuery, MemberEditQueryVariables>(
    MemberEditDocument,
    options,
  );
}
// @ts-ignore
export function useMemberEditSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MemberEditQuery,
    MemberEditQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MemberEditQuery, MemberEditQueryVariables>;
export function useMemberEditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberEditQuery,
        MemberEditQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MemberEditQuery | undefined,
  MemberEditQueryVariables
>;
export function useMemberEditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberEditQuery,
        MemberEditQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MemberEditQuery, MemberEditQueryVariables>(
    MemberEditDocument,
    options,
  );
}
export type MemberEditQueryHookResult = ReturnType<typeof useMemberEditQuery>;
export type MemberEditLazyQueryHookResult = ReturnType<
  typeof useMemberEditLazyQuery
>;
export type MemberEditSuspenseQueryHookResult = ReturnType<
  typeof useMemberEditSuspenseQuery
>;
export type MemberEditQueryResult = Apollo.QueryResult<
  MemberEditQuery,
  MemberEditQueryVariables
>;
